import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersListLayer from "../components/UsersListLayer";

const UsersPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Users Management" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <UsersListLayer />
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default UsersPage;
